<template>
  <div class="checkbox-item" :class="hasInfo ? 'has-info' : null" :disabled="disabled || null">
    <slot />
    <label :for="id">
      {{ title }}
    </label>
    <icon icon="check-bold" /> <slot name="info" /> <slot name="error" />
  </div>
</template>
<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: {
    Icon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasInfo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
:deep() {
  @include custom-radio-checkboxes;
}

@include custom-radio-checkboxes;

input:checked + label::before {
  border-color: $color-primary;
  background-color: $color-primary;
}

.checkbox-item {
  display: flex;
  align-items: center;
  position: relative;

  &[disabled] {
    label {
      color: #a3b7c0;
    }
    input:checked + label::before {
      border-color: $gray-dark;
      background-color: $gray-dark;
    }
  }

  &.has-info {
    :deep() svg {
      top: auto;
    }
  }
}

:deep() svg {
  @include icon(0.6em);
  position: absolute;
  color: $white;
  margin: 0.2em;
  top: 0.25em;
  left: 0;
  pointer-events: none;
}
:deep() .info-icon {
  margin-left: 1rem;
}
</style>
